/* ═══════════════════════════════════════════════════════════════
   stack-pdp.js — Arc Dept. The Stack
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── State ── */
  const state = {
    aesthetic:     null,   // 'clean-boy', 'streetwear', etc.
    aestheticName: null,   // 'Clean Boy', 'Streetwear', etc.
    metal:         null,   // 'gold' | 'silver'
    metalLabel:    null,   // 'Gold' | 'Silver'
    size:          null,   // 'XS' | 'S' | 'M' | 'L' | 'XL' — optional
  };

  /* ── Element refs ── */
  let selStyle, selMetal, selSize, styleConfirm,
      atcBtn, atcForm, propAesthetic, propMetal, propSize,
      stickyEl, stickyStatus, stickyBtn,
      styleTiles, metalTiles, sizeBtns;

  /* ════════════════════════════════
     Set text on all .st-atc-btn elements (inline + sticky)
  ════════════════════════════════ */
  function setAtcText(text) {
    document.querySelectorAll('.st-atc-btn').forEach(function (btn) {
      const textEl = btn.querySelector('.st-atc-btn__text');
      if (textEl) textEl.textContent = text;
      else btn.textContent = text;
    });
  }

  /* ════════════════════════════════
     Sync ATC button state
  ════════════════════════════════ */
  function syncAtcState() {
    /* Both aesthetic AND metal are required; size is optional */
    const ready = !!(state.aesthetic && state.metal);

    /* Summary list */
    if (selStyle) selStyle.textContent = state.aestheticName || '—';
    if (selMetal) selMetal.textContent = state.metalLabel    || '—';
    if (selSize)  selSize.textContent  = state.size          || 'Stylist will guide';

    /* Hidden form inputs */
    if (propAesthetic) propAesthetic.value = state.aestheticName || '';
    if (propMetal)     propMetal.value     = state.metalLabel    || '';
    if (propSize)      propSize.value      = state.size          || '';

    /* Button label */
    let label;
    if (!state.aesthetic) {
      label = 'Select your aesthetic above';
    } else if (!state.metal) {
      label = 'Select gold or silver';
    } else {
      label = 'Build My ' + state.aestheticName + ' Stack';
    }

    setAtcText(label);

    if (atcBtn) {
      atcBtn.disabled = !ready;
      atcBtn.setAttribute('aria-disabled', String(!ready));
    }
    if (stickyBtn) {
      stickyBtn.disabled = !ready;
    }

    /* Sticky bar status */
    if (stickyStatus) {
      if (!state.aesthetic) {
        stickyStatus.textContent = 'Choose your aesthetic above to begin';
      } else if (!state.metal) {
        stickyStatus.textContent = state.aestheticName + ' — choose metal';
      } else {
        const sizeNote = state.size ? ' · Size ' + state.size : '';
        stickyStatus.textContent = state.aestheticName + ' · ' + state.metalLabel + sizeNote;
      }
    }
  }

  /* ════════════════════════════════
     Style tile interaction
  ════════════════════════════════ */
  function onStyleTileClick(e) {
    const btn  = e.currentTarget;
    const id   = btn.dataset.style;
    const name = btn.dataset.styleName;

    state.aesthetic     = id;
    state.aestheticName = name;

    styleTiles.forEach(function (t) {
      const active = (t.dataset.style === id);
      t.setAttribute('aria-checked', String(active));
      t.classList.toggle('st-style-tile--selected', active);
    });

    if (styleConfirm) {
      styleConfirm.textContent = '✔ ' + name + ' — building your Signature';
    }

    /* Section 04 intro — dynamic post-selection */
    const setIntro = document.querySelector('.st-set-intro');
    if (setIntro && name) {
      setIntro.textContent =
        'Your ' + name + ' Signature contains one chain, one ring, and one bracelet — ' +
        'all hand-selected from our archive for the ' + name + ' direction.';
    }

    /* Cross-sell dynamic copy */
    const crosssellEl = document.querySelector('.st-crosssell__dynamic');
    if (crosssellEl && name) {
      crosssellEl.textContent =
        'The ' + name + ' Ring Edit — 5 vintage rings curated to your ' + name + ' aesthetic. $80.';
    }

    syncAtcState();

    /* Scroll toward metal section */
    const metalSection = document.getElementById('st-metal');
    if (metalSection) {
      setTimeout(function () {
        metalSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 220);
    }
  }

  /* ════════════════════════════════
     Metal tile interaction
  ════════════════════════════════ */
  function onMetalTileClick(e) {
    const btn   = e.currentTarget;
    const metal = btn.dataset.metal;   // 'gold' | 'silver'
    const label = btn.dataset.metalLabel || (metal === 'gold' ? 'Gold' : 'Silver');

    state.metal      = metal;
    state.metalLabel = label;

    metalTiles.forEach(function (t) {
      const active = (t.dataset.metal === metal);
      t.setAttribute('aria-checked', String(active));
      t.classList.toggle('st-metal-tile--selected', active);
    });

    syncAtcState();
  }

  /* ════════════════════════════════
     Size button interaction (optional)
  ════════════════════════════════ */
  function onSizeBtnClick(e) {
    const btn  = e.currentTarget;
    const size = btn.dataset.size;

    /* Toggle — clicking selected size deselects it (it's optional) */
    if (state.size === size) {
      state.size = null;
      btn.setAttribute('aria-checked', 'false');
      btn.classList.remove('st-size-btn--selected');
    } else {
      state.size = size;
      sizeBtns.forEach(function (b) {
        const active = (b.dataset.size === size);
        b.setAttribute('aria-checked', String(active));
        b.classList.toggle('st-size-btn--selected', active);
      });
    }

    syncAtcState();
  }

  /* ════════════════════════════════
     Cart AJAX submit
  ════════════════════════════════ */
  function onFormSubmit(e) {
    e.preventDefault();

    const variantInput = document.getElementById('st-variant-id');
    if (!variantInput) { atcForm.submit(); return; }

    const properties = {
      'Aesthetic': state.aestheticName || '',
      'Metal':     state.metalLabel    || '',
    };
    if (state.size) {
      properties['Ring Size'] = state.size;
    }

    const payload = {
      id:         variantInput.value,
      quantity:   1,
      properties: properties,
    };

    atcBtn.disabled = true;
    if (stickyBtn) stickyBtn.disabled = true;
    setAtcText('Adding…');

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed');
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:add',      { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      })
      .catch(function () {
        atcForm.submit();
      })
      .finally(function () {
        syncAtcState();
      });
  }

  /* ════════════════════════════════
     Sticky bar — show after hero scrolls out
  ════════════════════════════════ */
  function initStickyObserver() {
    const hero = document.getElementById('st-hero');
    if (!hero || !stickyEl) return;

    const io = new IntersectionObserver(
      function (entries) {
        const heroVisible = entries[0].isIntersecting;
        stickyEl.classList.toggle('st-sticky--visible', !heroVisible);
        stickyEl.setAttribute('aria-hidden', String(heroVisible));
      },
      { threshold: 0 }
    );
    io.observe(hero);
  }

  /* ════════════════════════════════
     Scroll reveal
  ════════════════════════════════ */
  function initReveal() {
    const reveals = document.querySelectorAll('.arc-stack-pdp .st-reveal');
    if (!reveals.length) return;

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('st-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ════════════════════════════════
     Init
  ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.arc-stack-pdp');
    if (!root) return;

    /* Refs */
    selStyle      = document.getElementById('st-sel-style');
    selMetal      = document.getElementById('st-sel-metal');
    selSize       = document.getElementById('st-sel-size');
    styleConfirm  = document.getElementById('st-style-confirm');
    atcBtn        = document.getElementById('st-atc-btn');
    atcForm       = document.getElementById('st-add-form');
    propAesthetic = document.getElementById('st-prop-aesthetic');
    propMetal     = document.getElementById('st-prop-metal');
    propSize      = document.getElementById('st-prop-size');
    stickyEl      = document.getElementById('st-sticky');
    stickyStatus  = document.getElementById('st-sticky-status');
    stickyBtn     = document.getElementById('st-sticky-btn');

    styleTiles = Array.from(root.querySelectorAll('.st-style-tile'));
    metalTiles = Array.from(root.querySelectorAll('.st-metal-tile'));
    sizeBtns   = Array.from(root.querySelectorAll('.st-size-btn'));

    /* Inject data-metal-label on metal tiles (read from name span) */
    metalTiles.forEach(function (t) {
      if (!t.dataset.metalLabel) {
        const nameEl = t.querySelector('.st-metal-tile__name');
        if (nameEl) t.dataset.metalLabel = nameEl.textContent.trim();
      }
    });

    /* Event listeners */
    styleTiles.forEach(function (t) {
      t.addEventListener('click', onStyleTileClick);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onStyleTileClick(e);
        }
      });
    });
    metalTiles.forEach(function (t) { t.addEventListener('click', onMetalTileClick); });
    sizeBtns.forEach(function (b)   { b.addEventListener('click', onSizeBtnClick);  });
    if (atcForm) atcForm.addEventListener('submit', onFormSubmit);

    /* Observers */
    initStickyObserver();
    initReveal();

    /* Initial state render */
    syncAtcState();
  });

})();
